module.exports = __webpack_public_path__ + "img/reward2.d0ce0794.png";